module.exports = __webpack_public_path__ + "static/media/tech-under.d61327aa.png";